import React, { useEffect, useState } from "react";
import {
  Container,
  Button,
  Row,
  Col,
  Table,
  Form,
  Image,
} from "react-bootstrap";
import axios from "axios";
import Header from "../components/LoanUnderwrite/Header";
import Steps from "../components/LoanUnderwrite/Steps";
import UserService from "../services/UserService";
import { useNavigate } from "react-router-dom";
import { toJpeg } from "html-to-image";
import jsPDF from "jspdf";
import { logWorkflowAction } from "../utils/workflowLogger";

const serverConfig = require("../config/server.js");

const UnderwriteLoan = ({ applicationInputs, setCurrentStep }) => {
  const [revealDetails, setRevealDetails] = useState(false);

  const [token, setToken] = useState(null);
  const [company, setCompany] = useState("");

  const [loanId, setLoanId] = useState("");
  const [loanUnderwrite, setLoanUnderwrite] = useState({});
  const [lookalikeAll, setLookalikeAll] = useState([]);
  const [lookalikeAssetType, setLookalikeAssetType] = useState([]);
  const [lookalikeLV, setLookalikeLV] = useState([]);
  const [selectedLookalikeType, setSelectedLookalikeType] = useState("all");
  const [showAlert, setShowAlert] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");

  const getDisplayedData = () => {
    if (selectedLookalikeType === "asset") return lookalikeAssetType;
    if (selectedLookalikeType === "lv") return lookalikeLV;
    return lookalikeAll;
  };
  const handleLogout = () => {
    sessionStorage.clear();
    UserService.doLogout();
  };

  const [loading, setLoading] = useState(false);
  const [actualScore, setActualScore] = useState("");
  const [actualRating, setActualRating] = useState("");
  const [decisionFlag, setDecisionFlag] = useState("");
  const [scoreType, setScoreType] = useState("");

  const handleUnderwrite = () => {
    setShowRightCol(true);
    setLoading(true);
    // Simulate underwriting delay
    setTimeout(() => {
      setLoading(false);
    }, 2000);
    setTimeout(() => {
      downloadPDF();
    }, 3000);
  };

  const getToken = () => {
    console.log(sessionStorage.getItem("token"));
    let jwt = UserService.getToken();
    axios
      .post(serverConfig.api_base_url + "user_get_token", { jwt: jwt })
      .then((response) => {
        console.log("user_get_token response", response);
        if (response.data.status === 200) {
          sessionStorage.setItem("token", response.data.token);
          setToken(response.data.token);
        } else if (response.data.status >= 400 && response.data.status <= 499) {
          alert(response.data.message);
        } else if (response.data.jwt_validation === "fail") {
          handleLogout();
        }
      })
      .catch((err) => console.log("error is", err));
  };

  function transformLookalikeData(data) {
    // Get all application IDs from one of the keys (e.g., from the first column)
    const firstKey = Object.keys(data)[0];
    const appIds = Object.keys(data[firstKey]);

    // Build an array of row objects
    return appIds.map((appId) => {
      const row = { appId }; // start with application ID
      for (const col in data) {
        row[col] = data[col][appId];
      }
      return row;
    });
  }

  useEffect(() => {
    console.log(sessionStorage.getItem("token"));
    if (sessionStorage.getItem("token") === null) {
      getToken();
    } else {
      setToken(sessionStorage.getItem("token"));
    }
  }, []);

  const [applicationNumber, setApplicationNumber] = useState(
    applicationInputs["Application Number"]
  );
  const [applicationScore, setApplicationScore] = useState("");
  const [applicationRating, setApplicationRating] = useState("");
  const [loanAmount, setLoanAmount] = useState("");
  const [lookalikeCounts, setLookalikeCounts] = useState({
    all: 0,
    asset: 0,
    lv: 0,
  });

  // const calculateActualScoreRating = (
  //   fico,
  //   yearsInBusiness,
  //   pgScore,
  //   corpScore,
  //   pgRating,
  //   corpRating,
  //   anyMajorDerog
  // ) => {
  //   let decisionFlag = "";

  //   if (fico > 0) {
  //     if (pgRating == "C") {
  //       decisionFlag = "Syndicate";
  //     }
  //     return [pgScore, pgRating, decisionFlag, "PG"];
  //   }
  //   if (anyMajorDerog) {
  //     return ["NA", "NA", "Major Derog", "Corp"];
  //   }
  //   if (yearsInBusiness >= 4) {
  //     if (corpRating == "C") {
  //       decisionFlag = "Syndicate";
  //     }
  //     return [corpScore, corpRating, decisionFlag, "Corp"];
  //   }
  //   if (yearsInBusiness < 4) {
  //     decisionFlag = "PG Required";
  //     return [corpScore, corpRating, decisionFlag, "Corp"];
  //   }
  // };

  const calculateActualScoreRating = (
    fico,
    yearsInBusiness,
    pgScore,
    corpScore,
    pgRating,
    corpRating,
    anyMajorDerog
  ) => {
    let decisionFlag = "";
    if (applicationInputs.usePGSwitch) {
      if (applicationInputs.pgRating == "C") {
        decisionFlag = "Syndicate";
      }
      return [
        applicationInputs.pgScore,
        applicationInputs.pgRating,
        decisionFlag,
        "PG",
      ];
    }
    if (applicationInputs.useCorpSwitch) {
      if (applicationInputs.anyMajorDerog) {
        return ["NA", "NA", "Major Derog", "Corp"];
      }
      if (applicationInputs.corpRating == "C") {
        decisionFlag = "Syndicate";
      }
      return [corpScore, corpRating, decisionFlag, "Corp"];
    }
  };

  const sendDecision = async (decision) => {
    try {
      const res = await axios.post(`${serverConfig.api_base_url}underwriting-engine/decision`, {
        id: loanId,
        decision: decision, // "Approve" | "UnderReview" | "Decline"
      });
      try {
        await logWorkflowAction(
          applicationInputs.applicationNumber,
          "decision",
          applicationInputs
        );
      } catch (error) {
        console.error("Error logging score loan action:", error);
      }
    } catch (err) {
      console.error("Error saving decision:", err);
    }
  };

  const downloadPDF = async () => {
    // Divs to capture
    const pages = [
      document.getElementById("customForm"),
      document.getElementById("decision"),
    ];

    // Capture each div as Image object
    const images = [];
    for (let i = 0; i < pages.length; i++) {
      const el = pages[i];
      if (!el) continue;

      const dataUrl = await toJpeg(el, {
        backgroundColor: "#0C1017",
        cacheBust: true,
        pixelRatio: 2,
      });

      const img = new window.Image();
      img.src = dataUrl;

      // const link = document.createElement("a");
      // link.href = dataUrl;
      // link.download = `${el.id}.jpeg`;
      // link.click();

      await new Promise((resolve) => {
        img.onload = () => {
          images.push(img);
          resolve();
        };
      });
    }

    // Compute total height and max width
    const padding = 20;
    const totalHeight = images.reduce((sum, img) => sum + img.height, 0);
    // const maxWidth = Math.max(...images.map((img) => img.width));
    const maxWidth = 1100 * 2; // fixed width for letter size

    // Create a single tall canvas
    const canvas = document.createElement("canvas");
    canvas.width = maxWidth + padding * 2;
    canvas.height = totalHeight + padding * 2;
    const ctx = canvas.getContext("2d");

    ctx.fillStyle = "#0C1017";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    // Draw images stacked vertically
    let offset = padding;
    images.forEach((img, index) => {
      // console.log(index, img.width, img.height);
      ctx.drawImage(img, padding, offset, maxWidth, img.height);
      offset += img.height;
    });

    // Convert combined canvas to Data URL
    const pdf = new jsPDF("p", "mm", "letter"); // letter page
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    const combinedDataUrl = canvas.toDataURL("image/jpeg");

    // Add combined image to PDF
    const imgWidth = pdfWidth;
    const imgHeight = (canvas.height * pdfWidth) / canvas.width;

    let position = 0;
    while (position < imgHeight) {
      pdf.setFillColor(12, 16, 23); // RGB for #0C1017
      pdf.rect(0, 0, pdfWidth, pdfHeight, "F");
      pdf.addImage(combinedDataUrl, "JPEG", 0, -position, imgWidth, imgHeight);
      position += pdfHeight;
      if (position < imgHeight) pdf.addPage();
    }

    pdf.save(`${applicationInputs.applicationNumber}.pdf`);
  };

  // useEffect(() => {
  //   const fetchApplicationData = async () => {
  //     try {
  //       const res = await axios.get(
  //         `${serverConfig.api_base_url}score/${applicationNumber}`
  //       );

  //       if (res.data.status === "success" && res.data.data) {
  //         const row = res.data.data;
  //         setApplicationScore(row["Points"] || "");
  //         setApplicationRating(row["Risk Rating"] || "");
  //         setLoanAmount(row["Approval Cost"] || "");
  //       }
  //     } catch (err) {
  //       console.error("Error fetching application data:", err);
  //     }
  //   };

  //   fetchApplicationData();
  // }, [applicationNumber]);

  useEffect(() => {
    if (token) {
      // Extract only the required API fields
      console.log("applicationInputs", applicationInputs);
      const [score, rating, decisionFlag, scoreType] =
        calculateActualScoreRating(
          applicationInputs.fico,
          applicationInputs.timeInBusiness,
          applicationInputs.pgScore,
          applicationInputs.corpScore,
          applicationInputs.pgRating,
          applicationInputs.corpRating,
          applicationInputs.anyMajorDerog
        );
      setActualScore(score);
      setActualRating(rating);
      setDecisionFlag(decisionFlag);
      setScoreType(scoreType);

      const payload = {
        AVG_HI_CREDIT: applicationInputs.highCredit || 0,
        COM_CRE_SCORE: applicationInputs.commercialCreditScore || 0,
        EMP_TOT: applicationInputs.numberOfEmployees || 0,
        LW_YRS_IN_BUS: applicationInputs.timeInBusiness || 0,
        NUM_INQ: applicationInputs.noOfInquiries || 0,
        NUM_TRADE_EXP: applicationInputs.noOfTradeExperiences || 0,
        NUMDELINQ: applicationInputs.noOfDelinquencies || 0,
        PAYDEX_FIRM: applicationInputs.paydex || 0,
        PN_MASTER_SCR: applicationInputs.pnMasterScore || 0,
        WASDELINQ: applicationInputs.noOfTotalDelinquencies || 0,
        FICO_AVG: applicationInputs.fico || 0,
        BANKRUPTCY: applicationInputs.bankruptcy == 1 ? 1 : 0,
        JUDGEMENTS: applicationInputs.judgements == "J" ? 1 : 0,
        LIENS: applicationInputs.liens == "L" ? 1 : 0,
        SUITS: applicationInputs.suits == "S" ? 1 : 0,
        Asset_Type: applicationInputs.assetType || "OTHER", // or applicationInputs.Asset_Type if stored that way
        Application_Number: applicationInputs.applicationNumber || 0, // or Application_Number
        Submit_Date:
          applicationInputs.submitDate ||
          new Date().toISOString().split("T")[0], // or applicationInputs.Submit_Date if stored that way
        Number_Of_Guarantors: applicationInputs.noOfGuarantors || 0,
        Submit_Cost: applicationInputs.loanAmount || 0,
        Is_New_Application: applicationInputs.isNewApplication ? 1 : 0,

        // -----------------------
        // Form fields (frontend)
        // -----------------------
        isNewApplication: applicationInputs.isNewApplication || false,
        applicationNumber: String(applicationInputs.applicationNumber) || "",
        nameOfBusiness: applicationInputs.nameOfBusiness || "",
        officeName: applicationInputs.officeName || "",
        loanAmount: applicationInputs.loanAmount || 0,
        assetType: applicationInputs.assetType || "OTHER",
        city: applicationInputs.city || "",

        // -----------------------
        // Bureau Details
        // -----------------------
        highCredit: applicationInputs.highCredit || 0,
        bankruptcy: applicationInputs.bankruptcy == "<NA>" ? 0 : 1,
        birthyear: applicationInputs.birthyear || 0,
        commercialCreditScore: applicationInputs.commercialCreditScore || 0,
        numberOfEmployees: applicationInputs.numberOfEmployees || 0,
        fico: applicationInputs.fico || 0,
        noOfGuarantors: applicationInputs.noOfGuarantors || 0,
        suits: applicationInputs.suits == "<NA>" ? 0 : 1,
        liens: applicationInputs.liens == "<NA>" ? 0 : 1,
        judgements: applicationInputs.judgements == "<NA>" ? 0 : 1,
        timeInBusiness: applicationInputs.timeInBusiness || 0,
        noOfDelinquencies: applicationInputs.noOfDelinquencies || 0,
        noOfInquiries: applicationInputs.noOfInquiries || 0,
        noOfTradeExperiences: applicationInputs.noOfTradeExperiences || 0,
        paydex: applicationInputs.paydex || 0,
        pnMasterScore: applicationInputs.pnMasterScore || 0,
        realStateBalance: applicationInputs.realStateBalance || 0,
        noOfSatisfactoryAccounts:
          applicationInputs.noOfSatisfactoryAccounts || 0,
        standardCode: applicationInputs.standardCode || "",
        startYear: applicationInputs.startYear || 0,
        totalRevolvingBalance: applicationInputs.totalRevolvingBalance || 0,
        totalRevolvingAvailable: applicationInputs.totalRevolvingAvailable || 0,
        vantage: applicationInputs.vantage || 0,
        noOfTotalDelinquencies: applicationInputs.noOfTotalDelinquencies || 0,
        yield_old: applicationInputs.yield || 0, // careful: backend renamed it
        optimismIndex: Number(applicationInputs.optimismIndex) || 0,
        gdpGrowthRate: Number(applicationInputs.gdpGrowthRate) || 0,
        cpiIndex: Number(applicationInputs.cpiIndex) || 0,
        fedFundsRate: Number(applicationInputs.fedFundsRate) || 0,
        industrialProductionIndex:
          Number(applicationInputs.industrialProductionIndex) || 0,
        unemploymentRate: Number(applicationInputs.unemploymentRate) || 0,
        cpiMoM: Number(applicationInputs.cpiMoM) || 0,
        cpiRoll3M: Number(applicationInputs.cpiRoll3M) || 0,
        gdpRoll3Q: Number(applicationInputs.gdpRoll3Q) || 0,
        unemploymentRoll3M: Number(applicationInputs.unemploymentRoll3M) || 0,
        optimismRoll6M: Number(applicationInputs.optimismRoll6M) || 0,
        industrialProdChange6M:
          Number(applicationInputs.industrialProdChange6M) || 0,
        covidFlag: parseInt(applicationInputs.covidFlag, 10) || 0,
        optimismIndexNormalized:
          Number(applicationInputs.optimismIndexNormalized) || 0,
        unemploymentRateNormalized:
          Number(applicationInputs.unemploymentRateNormalized) || 0,
        gdpGrowthRateNormalized:
          Number(applicationInputs.gdpGrowthRateNormalized) || 0,

        // -----------------------
        // PG Details
        // -----------------------
        pgTimeInBusiness: applicationInputs.pgTimeInBusiness || 0,
        pgFicoScore: applicationInputs.pgFicoScore || 0,
        pgStrongPaymentHistorySwitch:
          applicationInputs.pgStrongPaymentHistorySwitch || false,
        pgStrongPaymentHistorySwitchPoints:
          applicationInputs.pgStrongPaymentHistorySwitchPoints || 0,
        pgAcceptableCreditHistorySwitch:
          applicationInputs.pgAcceptableCreditHistorySwitch || false,
        pgAcceptableCreditHistorySwitchPoints:
          applicationInputs.pgAcceptableCreditHistorySwitchPoints || 0,
        pgStrongComparibleCreditSwitch:
          applicationInputs.pgStrongComparibleCreditSwitch || false,
        pgStrongComparibleCreditSwitchPoints:
          applicationInputs.pgStrongComparibleCreditSwitchPoints || 0,
        pgAcceptableComparibleCreditSwitch:
          applicationInputs.pgAcceptableComparibleCreditSwitch || false,
        pgAcceptableComparibleCreditSwitchPoints:
          applicationInputs.pgAcceptableComparibleCreditSwitchPoints || 0,
        pgPreferredCollateralSwitch:
          applicationInputs.pgPreferredCollateralSwitch || false,
        pgPreferredCollateralSwitchPoints:
          applicationInputs.pgPreferredCollateralSwitchPoints || 0,
        pgSoftCollateralSwitch:
          applicationInputs.pgSoftCollateralSwitch || false,
        pgSoftCollateralSwitchPoints:
          applicationInputs.pgSoftCollateralSwitchPoints || 0,
        pgIntangiblesSwitch: applicationInputs.pgIntangiblesSwitch || false,
        pgIntangiblesPoints: applicationInputs.pgIntangiblesPoints || 0,
        pgOverrideSwitch: applicationInputs.pgOverrideSwitch || false,
        pgOverridePoints: applicationInputs.pgOverridePoints || 0,
        pgOverrideText: applicationInputs.pgOverrideText || "",
        pgVendorCheck: applicationInputs.pgVendorCheck || false,

        // -----------------------
        // Corp Details
        // -----------------------
        corpTimeInBusiness: applicationInputs.corpTimeInBusiness || 0,
        corpTimeInBusinessPoints:
          applicationInputs.corpTimeInBusinessPoints || 0,
        corpNumberOfEmployees: applicationInputs.corpNumberOfEmployees || 0,
        corpNumberOfEmployeesPoints:
          applicationInputs.corpNumberOfEmployeesPoints || 0,
        corpHighCredit: applicationInputs.corpHighCredit || 0,
        corpHighCreditPoints: applicationInputs.corpHighCreditPoints || 0,
        corpPaydex: applicationInputs.corpPaydex || 0,
        corpPaydexPoints: applicationInputs.corpPaydexPoints || 0,
        corpTradeLines: applicationInputs.corpTradeLines || 0,
        corpTradeLinesPoints: applicationInputs.corpTradeLinesPoints || 0,
        suitsLiensJudgements: applicationInputs.suitsLiensJudgements || "",
        suitsLiensJudgementsPoints:
          applicationInputs.suitsLiensJudgementsPoints || 0,
        historyClearSwitch: applicationInputs.historyClearSwitch || false,
        historyClearPoints: applicationInputs.historyClearPoints || 0,
        uccFilingsSwitch: applicationInputs.uccFilingsSwitch || false,
        uccFilingsPoints: applicationInputs.uccFilingsPoints || 0,
        highRiskIndustrySwitch:
          applicationInputs.highRiskIndustrySwitch || false,
        highRiskIndustryPoints: applicationInputs.highRiskIndustryPoints || 0,
        comparableLeaseSwitch: applicationInputs.comparableLeaseSwitch || false,
        comparableLeasePoints: applicationInputs.comparableLeasePoints || 0,
        majorityEquitySingleOwnershipSwitch:
          applicationInputs.majorityEquitySingleOwnershipSwitch || false,
        majorityEquitySingleOwnershipPoints:
          applicationInputs.majorityEquitySingleOwnershipPoints || 0,
        preferredCollateralSwitch:
          applicationInputs.preferredCollateralSwitch || false,
        preferredCollateralPoints:
          applicationInputs.preferredCollateralPoints || 0,
        softCollateralSwitch: applicationInputs.softCollateralSwitch || false,
        softCollateralPoints: applicationInputs.softCollateralPoints || 0,
        intangiblesSwitch: applicationInputs.intangiblesSwitch || false,
        intangiblesPoints: applicationInputs.intangiblesPoints || 0,
        overrideSwitch: applicationInputs.overrideSwitch || false,
        overridePoints: applicationInputs.overridePoints || 0,
        overrideText: applicationInputs.overrideText || "",
        anyMajorDerog: applicationInputs.anyMajorDerog || false,
        vendorCheck: applicationInputs.vendorCheck || false,

        // -----------------------
        // Ratings
        // -----------------------
        pgScore: applicationInputs.pgScore || 0,
        pgRating: applicationInputs.pgRating || "",
        corpScore: applicationInputs.corpScore || 0,
        corpRating: applicationInputs.corpRating || "",
        decisionFlag: decisionFlag || "", // calculated in this component
        actualRating: applicationInputs.isNewApplication
          ? String(rating)
          : String(applicationInputs.actualRating),
        actualScore: applicationInputs.isNewApplication
          ? String(score)
          : String(applicationInputs.actualScore),
        scoreType: scoreType,

        fieldsModified: applicationInputs.fieldsModified,
        requiresPersonalGuarantor: applicationInputs.requiresPersonalGuarantor,
        corpThreeOfFourCriteriaFailed:
          applicationInputs.corpThreeOfFourCriteriaFailed,
        corpOneOfTwoCriteriaFailed:
          applicationInputs.corpOneOfTwoCriteriaFailed,
        loanShortfallSupportFailed:
          applicationInputs.loanShortfallSupportFailed,
      };
      console.log("payload", payload);
      axios
        .post(`${serverConfig.api_base_url}underwriting-engine/underwrite`, payload, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          console.log("loan_underwrite response", response.data);
          console.log(response.data.status);
          if (response.data.status === "success") {
            setLoanId(response.data.id);
            setLoanUnderwrite(response.data.prediction || {});
            setLookalikeAll(response.data.lookalike.all_similar || []);
            setLookalikeAssetType(response.data.lookalike.asset_similar || []);
            setLookalikeLV(response.data.lookalike.lv_similar || []);
            setLookalikeCounts(
              response.data.lookalike?.counts || { all: 0, asset: 0, lv: 0 }
            );
            console.log(
              "lookalikeAll before transform",
              response.data.lookalike.all_similar
            );
            console.log("lookalikeAll", lookalikeAll);
            console.log("loanUnderwrite", response.data.prediction);
            console.log("lookalikeData", response.data.lookalike);
          } else if (response.data.status === 301) {
            handleLogout();
          } else {
            alert(response.data.message || "Unexpected error occurred");
          }
        })
        .catch((err) => {
          console.error("Error underwriting loan:", err);
        });
    }
  }, [token]);

  const [showRightCol, setShowRightCol] = useState(false);

  return (
    <>
      <div className="loan-underwrite">
        {loanUnderwrite && (
          <Container fluid className="container-wrapper">
            {showAlert && (
              <div className="alert-msg">
                <Container fluid>{alertMsg}</Container>
              </div>
            )}
            <div style={{ height: "0px", overflow: "hidden" }}>
              <Row
                id="decision"
                className="mt-4 txt-yellow underwrite-loan"
                style={{
                  width: "1100px",
                  maxWidth: "1100px",
                  minWidth: "1100px",
                }}
              >
                <Col sm={4} className="text-center">
                  <Form.Group as={Row} className="mb-4 align-items-center">
                    <Form.Label column sm={4}>
                      App Number
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control
                        type="text"
                        value={applicationInputs.applicationNumber}
                        style={{ opacity: 1 }}
                        readOnly
                      />
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} className="mb-4 align-items-center">
                    <Form.Label column sm={4}>
                      App Score
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control
                        type="text"
                        value={
                          applicationInputs.isNewApplication
                            ? `${actualScore}${
                                scoreType ? ` (${scoreType})` : ""
                              }`
                            : applicationInputs.actualScore
                        }
                        style={{ opacity: 1 }}
                        readOnly
                      />
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} className="mb-4 align-items-center">
                    <Form.Label column sm={4}>
                      App Rating
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control
                        type="text"
                        value={
                          applicationInputs.isNewApplication
                            ? `${actualRating}${
                                decisionFlag ? ` (${decisionFlag})` : ""
                              }`
                            : applicationInputs.actualRating
                        }
                        style={{ opacity: 1 }}
                        readOnly
                      />
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} className="mb-4 align-items-center">
                    <Form.Label column sm={4}>
                      Loan Amount
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control
                        type="text"
                        value={applicationInputs.loanAmount}
                        style={{ opacity: 1 }}
                        readOnly
                      />
                    </Col>
                  </Form.Group>
                </Col>
                <Col
                  sm={4}
                  className="text-center d-flex flex-column align-items-center justify-content-center"
                  style={{ transition: "transform 0.2s ease" }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "scale(1.05)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "scale(1)")
                  }
                >
                  <Image
                    src={require("./../assets/images/athena-ai-underwrite.png")}
                    alt="Loan Process"
                    style={{
                      maxWidth: "80px",
                      marginBottom: "20px",
                      cursor: "pointer",
                    }}
                    onClick={handleUnderwrite}
                  />
                  <div>
                    <Button
                      variant="primary"
                      onClick={handleUnderwrite}
                      style={{ width: "150px" }}
                    >
                      Underwrite
                    </Button>
                  </div>
                </Col>
                <Col sm={4} className="text-center">
                  <Form.Group as={Row} className="mb-4 align-items-center">
                    <Form.Label column sm={4}>
                      Recommendation
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control
                        type="text"
                        placeholder="Enter here"
                        name="applicationNumber"
                        value={
                          decisionFlag === "Major Derog"
                            ? "Decline"
                            : loanUnderwrite.decision_general === null ||
                              loanUnderwrite.decision_general === undefined ||
                              loanUnderwrite.decision_general === "None"
                            ? "None"
                            : loanUnderwrite.decision_general === false
                            ? "Approve"
                            : "Decline"
                        }
                        style={{
                          opacity: 1,
                          backgroundColor: "#FD9F29",
                          color: "#191E27",
                        }}
                        readOnly
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-4 align-items-center">
                    <Form.Label column sm={4}>
                      Athena Score
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control
                        type="text"
                        placeholder="Enter here"
                        name="athenaScore"
                        value={
                          decisionFlag === "Major Derog"
                            ? "NA"
                            : typeof loanUnderwrite.general_proba ===
                                "string" &&
                              loanUnderwrite.general_proba.startsWith?.("NA")
                            ? loanUnderwrite.general_proba
                            : `${(
                                1000 -
                                loanUnderwrite.general_proba * 1000
                              ).toFixed(0)} (Must be > 874)`
                        }
                        title={
                          typeof loanUnderwrite.general_proba === "string" &&
                          loanUnderwrite.general_proba?.startsWith?.("NA")
                            ? loanUnderwrite.general_proba
                            : `${(
                                1000 -
                                loanUnderwrite.general_proba * 1000
                              ).toFixed(0)} (Must be > 874)`
                        }
                        style={{
                          opacity: 1,
                          backgroundColor: "#FD9F29",
                          color: "#191E27",
                          textOverflow: "ellipsis",
                        }}
                        readOnly
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-4 align-items-center">
                    <Form.Label column sm={4}>
                      Months to Default
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control
                        type="text"
                        placeholder="Enter here"
                        name="applicationNumber"
                        value={
                          decisionFlag === "Major Derog"
                            ? "NA"
                            : loanUnderwrite.month_to_default === "NA"
                            ? "NA"
                            : Number(
                                loanUnderwrite.month_to_default || 0
                              ).toFixed(0)
                        }
                        style={{
                          opacity: 1,
                          backgroundColor: "#FD9F29",
                          color: "#191E27",
                        }}
                        readOnly
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-4 align-items-center">
                    <Form.Label column sm={4}>
                      Yield
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control
                        type="text"
                        placeholder="Enter here"
                        name="yield"
                        value={
                          decisionFlag === "Major Derog"
                            ? "NA"
                            : loanUnderwrite.yield_fe === "NA"
                            ? "NA"
                            : Number(loanUnderwrite.yield_fe).toFixed(2)
                        }
                        style={{
                          opacity: 1,
                          backgroundColor: "#FD9F29",
                          color: "#191E27",
                        }}
                        readOnly
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
            </div>
            <Row className="txt-yellow underwrite-loan">
              <Col sm={4} className="text-center">
                <Form.Group as={Row} className="mb-4 align-items-center">
                  <Form.Label column sm={4}>
                    App Number
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      type="text"
                      value={applicationInputs.applicationNumber}
                      style={{ opacity: 1 }}
                      readOnly
                    />
                  </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-4 align-items-center">
                  <Form.Label column sm={4}>
                    App Score
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      type="text"
                      value={
                        applicationInputs.isNewApplication
                          ? `${actualScore}${
                              scoreType ? ` (${scoreType})` : ""
                            }`
                          : applicationInputs.actualScore
                      }
                      style={{ opacity: 1 }}
                      readOnly
                    />
                  </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-4 align-items-center">
                  <Form.Label column sm={4}>
                    App Rating
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      type="text"
                      value={
                        applicationInputs.isNewApplication
                          ? `${actualRating}${
                              decisionFlag ? ` (${decisionFlag})` : ""
                            }`
                          : applicationInputs.actualRating
                      }
                      style={{ opacity: 1 }}
                      readOnly
                    />
                  </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-4 align-items-center">
                  <Form.Label column sm={4}>
                    Loan Amount
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      type="text"
                      value={applicationInputs.loanAmount}
                      style={{ opacity: 1 }}
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
              <Col
                sm={4}
                className="text-center d-flex flex-column align-items-center justify-content-center"
                style={{ transition: "transform 0.2s ease" }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.transform = "scale(1.05)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              >
                <Image
                  src={require("./../assets/images/athena-ai-underwrite.png")}
                  alt="Loan Process"
                  style={{
                    maxWidth: "80px",
                    marginBottom: "20px",
                    cursor: "pointer",
                  }}
                  onClick={handleUnderwrite}
                />
                <div>
                  <Button
                    variant="primary"
                    onClick={handleUnderwrite}
                    style={{ width: "150px" }}
                  >
                    Underwrite
                  </Button>
                </div>
              </Col>
              {showRightCol && (
                <Col sm={4} className="text-center">
                  {loading ? (
                    <Image
                      src={require("./../assets/images/icons/spinner.gif")}
                      alt="Loading..."
                      style={{ maxWidth: "80px", marginTop: "50px" }}
                    />
                  ) : (
                    <>
                      <Form.Group as={Row} className="mb-4 align-items-center">
                        <Form.Label column sm={4}>
                          Recommendation
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Control
                            type="text"
                            placeholder="Enter here"
                            name="applicationNumber"
                            value={
                              decisionFlag === "Major Derog"
                                ? "Decline"
                                : loanUnderwrite.decision_general === null ||
                                  loanUnderwrite.decision_general ===
                                    undefined ||
                                  loanUnderwrite.decision_general === "None"
                                ? "None"
                                : loanUnderwrite.decision_general === false
                                ? "Approve"
                                : "Decline"
                            }
                            style={{
                              opacity: 1,
                              backgroundColor: "#FD9F29",
                              color: "#191E27",
                            }}
                            readOnly
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} className="mb-4 align-items-center">
                        <Form.Label column sm={4}>
                          Athena Score
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Control
                            type="text"
                            placeholder="Enter here"
                            name="athenaScore"
                            value={
                              decisionFlag === "Major Derog"
                                ? "NA"
                                : typeof loanUnderwrite.general_proba ===
                                    "string" &&
                                  loanUnderwrite.general_proba.startsWith?.(
                                    "NA"
                                  )
                                ? loanUnderwrite.general_proba
                                : `${(
                                    1000 -
                                    loanUnderwrite.general_proba * 1000
                                  ).toFixed(0)} (Must be > 874)`
                            }
                            title={
                              typeof loanUnderwrite.general_proba ===
                                "string" &&
                              loanUnderwrite.general_proba?.startsWith?.("NA")
                                ? loanUnderwrite.general_proba
                                : `${(
                                    1000 -
                                    loanUnderwrite.general_proba * 1000
                                  ).toFixed(0)} (Must be > 874)`
                            }
                            style={{
                              opacity: 1,
                              backgroundColor: "#FD9F29",
                              color: "#191E27",
                              textOverflow: "ellipsis",
                            }}
                            readOnly
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} className="mb-4 align-items-center">
                        <Form.Label column sm={4}>
                          Months to Default
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Control
                            type="text"
                            placeholder="Enter here"
                            name="applicationNumber"
                            value={
                              decisionFlag === "Major Derog"
                                ? "NA"
                                : loanUnderwrite.month_to_default === "NA"
                                ? "NA"
                                : Number(
                                    loanUnderwrite.month_to_default || 0
                                  ).toFixed(0)
                            }
                            style={{
                              opacity: 1,
                              backgroundColor: "#FD9F29",
                              color: "#191E27",
                            }}
                            readOnly
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} className="mb-4 align-items-center">
                        <Form.Label column sm={4}>
                          Yield
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Control
                            type="text"
                            placeholder="Enter here"
                            name="yield"
                            value={
                              decisionFlag === "Major Derog"
                                ? "NA"
                                : loanUnderwrite.yield_fe === "NA"
                                ? "NA"
                                : Number(loanUnderwrite.yield_fe).toFixed(2)
                            }
                            style={{
                              opacity: 1,
                              backgroundColor: "#FD9F29",
                              color: "#191E27",
                            }}
                            readOnly
                          />
                        </Col>
                      </Form.Group>
                    </>
                  )}
                </Col>
              )}
            </Row>
            <div className="mt-4 mb-3 text-center">
              <Button
                variant="primary"
                className="mx-1"
                onClick={() => {
                  sendDecision("Reject");
                  setCurrentStep("Loans");
                }}
                style={{ width: "150px" }}
              >
                Reject
              </Button>
              <Button
                variant="transparent"
                className="mx-1"
                onClick={() => {
                  sendDecision("UnderReview");
                  setCurrentStep("Loans");
                }}
                style={{ width: "150px" }}
              >
                Under Review
              </Button>
              <Button
                variant="primary"
                className="mx-1"
                onClick={() => {
                  sendDecision("Approve");
                  setCurrentStep("Loans");
                }}
                style={{ width: "150px" }}
                disabled={
                  decisionFlag === "Major Derog" ||
                  decisionFlag === "PG Required" ||
                  (applicationInputs.loanAmount > 100000 &&
                    applicationInputs.useCorpSwitch &&
                    applicationInputs.actualRating !== "A1")
                }
              >
                Approve
              </Button>
              <div className="mb-4 mt-4 divider"></div>
            </div>
            <div
              className="text-center mb-3"
              style={{
                color: "#FD9F29",
              }}
            >
              {`Application number `}
              <strong>{applicationInputs.applicationNumber}</strong>
              {` matches `}
              <strong>{lookalikeCounts["all"] || 0}</strong>
              {` contracts on our portfolio.`}
            </div>
            <div className="mb-4 mt-4 divider"></div>
            <div className="mt-4 mb-5 text-center">
              <Button
                variant="plain"
                onClick={() => setRevealDetails(!revealDetails)}
              >
                {revealDetails ? "Hide Lookalikes" : "Show Lookalikes"}
              </Button>
            </div>
            {revealDetails && (
              <div className="mt-3">
                <Button
                  variant={
                    selectedLookalikeType === "all" ? "primary" : "secondary"
                  }
                  onClick={() => setSelectedLookalikeType("all")}
                  className="mx-1"
                >
                  All Loans
                </Button>
                <Button
                  variant={
                    selectedLookalikeType === "asset" ? "primary" : "secondary"
                  }
                  onClick={() => setSelectedLookalikeType("asset")}
                  className="mx-1"
                >
                  Asset Type
                </Button>
                <Button
                  variant={
                    selectedLookalikeType === "lv" ? "primary" : "secondary"
                  }
                  onClick={() => setSelectedLookalikeType("lv")}
                  className="mx-1"
                >
                  Loan Value
                </Button>
              </div>
            )}

            {revealDetails && (
              <Table>
                <thead>
                  <tr>
                    <th>Application Number</th>
                    <th>FICO_AVG</th>
                    <th>Submit Cost</th>
                    <th>LW_YRS_IN_BUS</th>
                    <th>EMP_TOT</th>
                    <th>NUMDELINQ</th>
                    <th>NUM_INQ</th>
                    <th>Asset Type</th>
                    <th>Industry</th>
                    <th>Default_TF</th>
                  </tr>
                </thead>
                <tbody>
                  {getDisplayedData().map((row, idx) => (
                    <tr key={idx}>
                      <td>{row["Application Number"] ?? row.appId ?? "N/A"}</td>
                      <td>{row.FICO_AVG ?? "N/A"}</td>
                      <td>{row["Submit Cost"] ?? "N/A"}</td>
                      <td>{row.LW_YRS_IN_BUS ?? "N/A"}</td>
                      <td>{row.EMP_TOT ?? "N/A"}</td>
                      <td>{row.NUMDELINQ ?? "N/A"}</td>
                      <td>{row.NUM_INQ ?? "N/A"}</td>
                      <td>{row["Asset Type"] ?? "N/A"}</td>
                      <td>{row.Industry ?? "N/A"}</td>
                      <td>
                        {row.Default_TF === undefined || row.Default_TF === null
                          ? "N/A"
                          : String(row.Default_TF)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </Container>
        )}
      </div>
    </>
  );
};

export default UnderwriteLoan;
